export function isSP() {
  return window.innerWidth < 768
}

export function qs(selector, scope = document) {
  return scope.querySelector(selector)
}

export function qsAll(selector, scope = document) {
  return scope.querySelectorAll(selector)
}

export function vw(val, designWidth = 390, stageWidth = window.innerWidth) {
  return (val / designWidth) * stageWidth
}

const delayedCallStates = new Map()
const delayedCallTimerIndex = new Map()
let delayedCallVisibilityBound = false
let delayedCallStateSeq = 0

const now = () => Date.now()

const registerTimerRef = (state, timerRef) => {
  state.timerRefs.add(timerRef)
  delayedCallTimerIndex.set(timerRef, state.id)
}

const clearState = (state) => {
  if(state.timeoutRef != null) {
    clearTimeout(state.timeoutRef)
  }

  state.timerRefs.forEach((timerRef) => {
    delayedCallTimerIndex.delete(timerRef)
  })

  delayedCallStates.delete(state.id)
}

const pauseState = (state) => {
  if(state.timeoutRef == null) return

  const elapsed = now() - state.startedAt
  state.remainingMs = Math.max(state.remainingMs - elapsed, 0)

  clearTimeout(state.timeoutRef)
  state.timeoutRef = null
}

const runState = (state) => {
  state.timeoutRef = null

  if(typeof document !== 'undefined' && document.hidden) {
    state.remainingMs = 0
    return
  }

  clearState(state)
  state.func()
}

const scheduleState = (state) => {
  if(state.timeoutRef != null) return

  state.startedAt = now()

  const timeoutRef = setTimeout(() => {
    runState(state)
  }, Math.max(0, state.remainingMs))

  state.timeoutRef = timeoutRef
  registerTimerRef(state, timeoutRef)
}

const pauseAllDelayedCall = () => {
  delayedCallStates.forEach((state) => {
    pauseState(state)
  })
}

const resumeAllDelayedCall = () => {
  delayedCallStates.forEach((state) => {
    scheduleState(state)
  })
}

const bindDelayedCallVisibilityHandler = () => {
  if(delayedCallVisibilityBound) return
  if(typeof document === 'undefined' || !document.addEventListener) return

  delayedCallVisibilityBound = true

  document.addEventListener('visibilitychange', () => {
    if(document.hidden) {
      pauseAllDelayedCall()
      return
    }

    resumeAllDelayedCall()
  })
}

export const delayedCall = (func, wait) => {
  bindDelayedCallVisibilityHandler()

  const delayMs = Math.max(0, Number(wait || 0) * 1000)
  const state = {
    id: ++delayedCallStateSeq,
    func,
    remainingMs: delayMs,
    startedAt: 0,
    timeoutRef: null,
    timerRefs: new Set(),
  }

  delayedCallStates.set(state.id, state)

  scheduleState(state)

  const handle = state.timeoutRef

  if(typeof document !== 'undefined' && document.hidden) {
    pauseState(state)
  }

  return handle
}

export const killDelayedCall = (int) => {
  const directState = delayedCallStates.get(int)
  if(directState) {
    clearState(directState)
    return
  }

  const stateId = delayedCallTimerIndex.get(int)

  if(stateId == null) {
    clearTimeout(int)
    return
  }

  const state = delayedCallStates.get(stateId)
  if(!state) {
    delayedCallTimerIndex.delete(int)
    return
  }

  clearState(state)
}

export const killAllDelayedCall = () => {
  delayedCallStates.forEach((state) => {
    clearState(state)
  })
}
